<script lang="ts" setup>
import type { OfferBalance, OfferFull, OfferMedium } from '~/types/Catalog';

const { offer, offerBalances } = defineProps<{
  offer: OfferFull | OfferMedium;
  offerBalances?: OfferBalance[] | null;
}>();

const authStore = useAuthStore();
const displayedOfferBalances = computed(() => (offerBalances === undefined ? offer.offer_balances : offerBalances));

const warehouses = computed(() =>
  displayedOfferBalances.value
    ?.map((w) => ({
      ...w,
      name: w.warehouse.name.match(/\(([^)]+)\)/)?.[1] || w.warehouse.name,
    }))
    .filter((w) => w.warehouse.show && w.warehouse.name)
    .sort((a, b) => a.warehouse.id - b.warehouse.id),
);
</script>

<template>
  <section
    v-if="authStore.isLogged && authStore.accessRights?.can_view_balance && displayedOfferBalances"
    class="text-sm"
  >
    <p class="mb-1 italic text-black-80">Наличие (для&nbsp;сотрудника)</p>

    <ul class="flex flex-col list-none p-0">
      <li
        v-for="warehouse in warehouses"
        :key="warehouse.warehouse.id"
      >
        <div class="flex items-center gap-1.5">
          <div
            :class="warehouse.balance ? 'bg-green' : 'bg-red'"
            class="rounded-full w-1.5 h-1.5 flex-shrink-0"
          />

          <div class="leading-5">
            {{ warehouse.name }}:
            <span class="font-bold">{{ warehouse.balance }}</span>
          </div>
        </div>
      </li>

      <li>
        <div class="flex items-center gap-1 mt-2 -ml-1">
          <SvgoStar
            class="text-xs"
            filled
          />

          <div class="leading-5">Ранг: {{ offer.popularity_rank || '–' }}</div>
        </div>
      </li>
    </ul>
  </section>
</template>
